<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader" />
      <rule-game :title="ruleTitle.payout" :value="rulePayout" />
      <rule-game :title="ruleTitle.rule" :value="ruleGame" />
      <rule-game :title="ruleTitle.score" :value="ruleScore" />
      <rule-game :title="ruleTitle.paytable" :value="rulePaytable" />
    </div>
  </div>
</template>

<script>
import Bg2banner from '../../assets/gamerule/bingo2/Board_BingoV2.png';
import Bg2rule1 from '../../assets/gamerule/bingo2/Bingo2_Info_Game_1.png';
import Bg2rule2 from '../../assets/gamerule/bingo2/Bingo2_Info_Game_2.png';
import Bg2rule3 from '../../assets/gamerule/bingo2/Bingo2_Info_Game_3.png';
import Bg2rule4 from '../../assets/gamerule/bingo2/Bingo2_Info_Game_4.png';
import Bg2rule5 from '../../assets/gamerule/bingo2/Bingo2_Asset_Info_Web_1.png';
import Bg2rule6 from '../../assets/gamerule/bingo2/Bingo2_Info_Game_5.png';
import Bg2rule7 from '../../assets/gamerule/bingo2/Bingo2_Info_Game_6.png';
import Bg2rule8 from '../../assets/gamerule/bingo2/Bingo2_Info_Game_7.png';
import Bg2rule9 from '../../assets/gamerule/bingo2/Bingo2_Info_Game_8.png';
import Bg2rule10 from '../../assets/gamerule/bingo2/Bingo2_Info_Game_9.png';
import Bg2rule11 from '../../assets/gamerule/bingo2/Bingo2_Info_Game_10.png';
import Bg2rule12 from '../../assets/gamerule/bingo2/Bingo2_Info_Game_11.png';
import Bg2rule13 from '../../assets/gamerule/bingo2/Bingo2_Info_Game_12.png';
import Bg2rule14 from '../../assets/gamerule/bingo2/Bingo2_Info_Game_13.png';
import Bg2rule15 from '../../assets/gamerule/bingo2/Bingo2_Asset_Info_Web_2.png';

export default {
  name: 'rule_bingo2',
  data() {
    return {
      ruleHeader: {
        gameName: 'บิงโก 2 (Bingo 2)',
        boardImg: Bg2banner,
      },
      ruleTitle: {
        payout: 'อัตราจ่าย',
        rule: 'กติกาและคำอธิบาย',
        score: 'การคำนวณ',
        paytable: 'ไลน์บิงโก',
      },
      rulePayout: [
        {
          type: 'textBg2',
          text: 'อัตราจ่าย 1 : 0.97',
          class: 'ml-3',
        },
        {
          type: 'textBg2',
          text: 'หากผู้เล่นลงเดิมพัน 100 บาท และได้รับชัยชนะ ผู้เล่นจะได้รับเงินจากการเดิมพัน 97 บาท',
          class: 'ml-3',
        },
      ],
      ruleGame: [
        {
          type: 'ruleGame-bingo2',
          text: 'จำนวนผู้เล่นต่อ 1 ห้อง มีได้ตั้งแต่',
          textCol: ' 2-30 ',
          textCon: 'คน',
          text2: 'เมื่อเข้ามาในห้องแล้ว สามารถซื้อการ์ดบิงโกได้สูงสุดที่',
          textCol2: ' 4 ',
          textCon2: 'ใบ แล้วหากไม่ถูกใจตัวเลขของการ์บิงโกที่ได้รับ',
          text3: 'สามารถ',
          textCol3: 'กดสุ่ม',
          textCon3: 'ใบใหม่ได้ทันทีโดยไม่เสียค่าใช้จ่ายเพิ่ม และเกมส์จะเริ่มก็ต่อเมื่อ ไม่มีผู้เล่นเข้าใหม่ในห้องภายใน',
          textCol3_2: ' 15 ',
          textCon3_2: 'วินาที',
          image: Bg2rule1,
          image2: Bg2rule2,
          textCol4: 'รางวัลสูงสุด',
          text4: ' อาทิ ',
          textCol4_2: 'มือใหม่ โต๊ะ 100 ',
          textCon4: 'หากในห้องของผู้เล่นนั้น มีจำนวนผู้เล่นคนอื่นรวมแล้ว',
          textCol4_3: ' 30 ',
          textCon4_2: 'คน และทั้ง',
          textCol4_4: ' 30 ',
          textCon4_3: 'คน ซื้อการ์ดเป็นจำนวน',
          textCol4_5: ' 4 ',
          textCon4_4: 'ใบ ยอดรางวัลสูงสุดของห้องจะเป็น(100x4)x30 = ',
          textCol4_6: ' 12,000 ',
          textCon4_5: 'บาท ',
          textCol4_7: 'จำนวนตัวเลขของเกมส์บิงโกอยู่ที่ 1-100',
          image3: Bg2rule3,
          class1: 'w-50',
          text5: 'เกมส์จะทำการ',
          textCol5: ' สุ่มเลขโบนัส (Lucky Number) ',
          textCon5: 'อัตโนมัติทั้ง',
          textCol5_2: ' 3 ตัว ',
          textCon5_2: 'ให้กับผู้เล่นทันที',
          textCol5_3: ' (มีเลข 1-100) ',
          textCon5_3: 'โดยแต่ละการ์ดจะมีช่อง',
          textCol5_4: ' Free ',
          textCon5_4: 'อยู่ตรงกลางของการ์ด จากนั้นเกมส์จะทำการสุ่มอัตโนมัติให้ผู้เล่นได้ลุ้นกัน',
          textCol5_5: 'รูปดาว',
          textCon5_5: ' เป็น ',
          textCol5_6: 'Lucky Number',
          textCon5_6: ' และ ',
          textCol5_7: 'วงกลมสีแดง',
          textCon5_7: ' เป็นเบี้ย ',
          textCol5_8: 'ตัวเลขปกติ',
          image4: Bg2rule4,
          image5: Bg2rule5,
          text6: 'หากผลออกแล้วผู้เล่นดูผลที่ออกไม่ทัน สามารถดูผลได้ที่ตารางด้านซ้าย',
          textCol6: ' กากบาทแดง ',
          textCon6: 'คือตัวเล่นสุ่มปกติ',
          textCol6_2: 'ช่องเขียว',
          textCon6_2: ' คือตัวเล่นสุ่ม ',
          textCol6_3: ' Lucky Number',
          textCol6_4: '5 อันดับแรก',
          textCon6_3: ' ที่อยู่ด้านบนสุด คือ 5 อันดับของผู้เล่นที่ใกล้บิงโก ดูผลที่ออกล่าสุดได้โดยดูจากลูกบอลด้านขวา',
          image6: Bg2rule6,
          image7: Bg2rule7,
          textCol7: 'หากผู้เล่นท่านอื่นบิงโก ',
          text7: 'เกมส์จะทำการหยุดสุ่มเลข แล้วให้ผู้เล่นเช็คตัวเลขที่ตกหล่น และ 5 วินาทีสุดท้าย เกมส์จะเช็คตัวเลขอัตโนมัติให้ทันทีหากผู้เล่นเช็คไม่ละเอียด',
          image8: Bg2rule8,
          image9: Bg2rule9,
          text8: 'เมื่อมีผู้เล่นได้บิงโก เกมส์จะจบลงและหน้าสรุปผลขึ้นทันที ',
          textCol8: '(หน้าสรุปผลจะไม่แสดงยอดของผู้เล่นที่ไม่ได้บิงโก)',
          textCon8: 'หากตานั้นมีผู้เล่นที่ได้บิงโกพร้อมกัน',
          textCol8_2: ' 6 ',
          textCon8_2: 'เงินเดิมพันจากยอด',
          textCol8_3: ' 10,000 ',
          textCon8_3: 'บาท',
          textCon8_4: 'จะแบ่งให้กับ',
          textCol8_4: ' 6 ',
          textCon8_5: 'คนที่บิงโกจำนวนคนละ 1,666 บาท (หักอัตราการจ่าย 1 : 0.97)',
          textCon8_6: 'และผู้เล่นใดที่ได้รับแต้ม',
          textCol8_5: ' Lucky Number ',
          textCon8_7: 'จะได้บวกเงินเพิ่มเติมจำนวนต่อเลข 10% ของค่าห้อง',
          image10: Bg2rule10,
          image11: Bg2rule11,
        },
      ],
      ruleScore: [
        {
          type: 'textBg2Color',
          text: 'ผู้เล่นที่ได้บิงโก',
          textCol: ' 1 ',
          text2: ' คน จะได้เงินเดิมพันทั้งหมด',
        },
        {
          type: 'textBg2Color',
          text: 'ผู้เล่นที่ได้บิงโกมากกว่า',
          textCol: ' 2 ',
          text2: ' คน เงินเดิมพันทั้งหมด จะแบ่งขจ่ายให้กับผู้เล่นที่บิงโกเท่านั้น',
        },
        {
          type: 'textBg1Color',
          text: 'กรณี ห้อง 100 และผู้เล่นทั้งหมดของห่้อง ซื้อ 4 ใบ จะได้รับเงินเดิมพันของห้อง และได้รับ Lucky Number ตามจำนวนที่ในการ์ด อาทิ ได้รับ 12,000 บาท หัก',
          textCol: 'ค่าอัตราจ่าย 1 : 0.97 = 9,700 บาท',
        },
        {
          type: 'image',
          image: Bg2rule12,
          class: 'w-50',
        },
        {
          type: 'textBg2Color',
          text: 'กรณีที่มีผู้เล่นชนะ',
          textCol: ' 1 ',
          text2: ' คน',
        },
        {
          type: 'textBg2',
          text: 'ผู้เล่นที่ชนะบิงโก จะได้เงินเดิมพันของผู้เล่นที่แพ้ทั้งหมด',
          textCol: ' 1 ',
        },
        {
          type: 'twoImage',
          image: Bg2rule13,
          image2: Bg2rule14,
        },
        {
          type: 'textBg2Color2',
          text: 'กรณีที่มีผู้เล่นชนะ',
          textCol: ' 2 ',
          text2: 'คน หรือมากกว่า',
          textCol2: ' 2 ',
          text3: 'คน',
        },
        {
          type: 'textBg2',
          text: 'ผู้เล่นที่บิงโกชนะ จะได้เงินเดิมพันของผู้เล่นที่แพ้ทั้งหมด',
        },
        {
          type: 'textBg2',
          text: 'โดยการแบ่งจ่ายคนละครึ่งของเงินเดิมพัน',
        },
      ],
      rulePaytable: [
        {
          type: 'textBg2',
          text: 'ไลน์บิงโกมีจำนวน 14 ไลน์ ดั่งต่อไปนี้',
        },
        {
          type: 'image',
          image: Bg2rule15,
        },
      ],
    };
  },
};
</script>
